<div class="file-upload" [ngClass]="{ 'file-upload--error': hasErrors }">
  <div [formGroup]="myForm" (ngSubmit)="submit()">
    @if (loadingService.loading()) {
      <div class="flex flex-col gap-y-6">
        <ngx-skeleton-loader
          [count]="1"
          [theme]="{
            'border-radius': '.5em',
            width: '5em',
            height: '1em',
            margin: '0',
          }"></ngx-skeleton-loader>
        <ngx-skeleton-loader
          [count]="1"
          [theme]="{
            'border-radius': '.5em',
            width: '19em',
            height: '16em',
            margin: '0',
          }"></ngx-skeleton-loader>
      </div>
    }
    <label
      class="file-upload__label"
      [class.!hidden]="loadingService.loading()">
      {{ label() | translate }}
      @if (subLabel()) {
        <span class="file-upload__sub-label">{{ subLabel() | translate }}</span>
      }
      @if (!!this.messages()['required']) {
        <span class="file-upload__required">*</span>
      }
    </label>
    <div
      class="file-upload__box"
      [ngClass]="{ '!w-full': wFull }"
      pwjDragDrop
      [class.!hidden]="loadingService.loading()"
      (onFileDropped)="onFilesDropped($event)">
      <i class="iconsax file-upload__icon" icon-name="cloud-add"></i>
      @if (accept() === 'image') {
        <p class="file-upload__title">
          {{ 'uploader.dragAndDropYourImage' | translate }}
        </p>
      } @else if (accept() === 'video') {
        <p class="file-upload__title">
          {{ 'uploader.dragAndDropYourVideo' | translate }}
        </p>
      }
      <div class="file-upload__or">
        <span class="file-upload__or-text">{{
          'uploader.or' | translate
        }}</span>
      </div>
      <pwj-button
        [disabled]="disabled"
        [variant]="buttonsVariant() || 'secondary'"
        [color]="buttonsColor() || 'default'"
        icon="chevron-right"
        [iconReversePosition]="true"
        [rotateIconInRtl]="true"
        (click)="inputFile()?.nativeElement.click()">
        {{ 'uploader.browseFile' | translate }}
      </pwj-button>
    </div>
    <input
      class="hidden"
      #fileInput
      [accept]="checkAccept()"
      type="file"
      (change)="onFileChange($event)"
      multiple />
    <div class="file-upload__images" [class.!hidden]="loadingService.loading()">
      @for (img of images; track img; let i = $index) {
        <div class="file-upload__image-box">
          @if (progress > 0) {
            <div class="file-upload__progress">
              <div
                class="file-upload__progress-bar"
                role="progressbar"
                [style.height.%]="progress">
                {{ progress }}%
              </div>
            </div>
          }
          @if (accept() === 'image' && img?.thumbnail) {
            <img
              class="file-upload__image"
              [src]="img?.thumbnail | imageSource: false"
              alt="" />
          } @else if (accept() === 'video' && img.url) {
            <video
              class="file-upload__video"
              [src]="img.url | imageSource: false"></video>
          }
          @if (progress === 0 && !disabled) {
            @if (
              (accept() === 'video' && img.url) ||
              (accept() === 'image' && img?.thumbnail)
            ) {
              <i
                class="iconsax file-upload__remove"
                icon-name="trash"
                (click)="removeImage(i)"></i>
            }
            @if (accept() === 'video' && img.url) {
              <i
                class="iconsax file-upload__maximize"
                icon-name="maximize-1"
                (click)="openVideoPreviewDialog(img.url)"></i>
            } @else if (accept() === 'image' && img?.thumbnail) {
              <i
                class="iconsax file-upload__maximize"
                icon-name="maximize-1"
                (click)="openImagePreviewDialog(img.thumbnail)"></i>
            }
          }
        </div>
      }
    </div>
    @if (hasErrors) {
      <div
        class="file-upload__errors"
        [class.!hidden]="loadingService.loading()">
        @for (error of messages() | keyvalue; track error) {
          @if (getErrors?.[error.key]) {
            <span class="file-upload__error">{{
              error.value | translate
            }}</span>
          }
        }
      </div>
    }
    <div
      class="file-upload__actions"
      [class.!hidden]="loadingService.loading()">
      @if (!disabled) {
        @if (uploading) {
          <pwj-button
            [disabled]="disabled"
            [variant]="buttonsVariant() || 'secondary'"
            [color]="buttonsColor() || 'default'"
            type="button"
            size="large"
            [rotateIconInRtl]="true"
            icon="chevron-right"
            [iconReversePosition]="true"
            (click)="cancel()">
            {{ 'uploader.cancel' | translate }}
          </pwj-button>
        }
        @if (!hideButtons) {
          <pwj-button
            [disabled]="disabled"
            [variant]="buttonsVariant() || 'primary'"
            [color]="buttonsColor() || 'default'"
            type="button"
            size="large"
            (click)="submit()"
            [rotateIconInRtl]="true"
            icon="chevron-right"
            [iconReversePosition]="true">
            {{ 'uploader.submit' | translate }}
          </pwj-button>
        }
      }
    </div>
  </div>
</div>
